import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { InvoicesPage } from '@/features/procurement/invoices-page';

const searchSchema = z.object({
  /** Open this invoice (e.g. one just recorded from a scan). */
  invoice: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/procurement/invoices')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { invoice } = Route.useSearch();
  return <InvoicesPage {...params} invoiceId={invoice} />;
}
